import React from "react";
import styles from '../styles/bettingHistory.module.scss'
import SpriteContainer from "@/wmCompoments/spriteContainer";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

const BettingHistory = () => {
    const navigate = useNavigate()
    const { t } = useTranslation('centralWallet')

    return <div className={styles.bettingHistory}>
        <div className={styles.title}>
            <div className={styles.title_text}>{t('betRecord')}</div>
            <div className={styles.title_details} onClick={()=>{navigate('/mine/betOrderRecords')}}>
                <span>{t('viewDetails')}</span>
                <SpriteContainer name="icon_chevron_right_night" module={'wallet'}  />
            </div>
        </div>

        <div>
            
        </div>
    </div>
}

export default BettingHistory